import flatpickr from "flatpickr";
import { Slovak } from "flatpickr/dist/l10n/sk"
import moment from 'moment';

export const initDatepickers = () => {
    const elements = [...document.querySelectorAll('.datepicker')].filter(el => !el.classList.contains('is-datepicker-initialized'))

    for (const el of elements) {
        const onUpdateValueCallbacks = [];

        let options = {};

        if (el.getAttribute('data-min-date')) {
            options['minDate'] = new Date(el.getAttribute('data-min-date'));
        }

        if (el.getAttribute('data-formatted-input-selector')) {
            onUpdateValueCallbacks.push((dateStr, instance) => {
                const formattedDateStr = moment(dateStr, 'DD.MM.YYYY').format('YYYY-MM-DD');

                document.querySelector(el.getAttribute('data-formatted-input-selector')).value = formattedDateStr;
            })
        }

        el.setAttribute('autocomplete', 'off')

        flatpickr(el, {...{
            disableMobile: true,
            allowInput: true,
            locale: Slovak,
            dateFormat: 'd.m.Y',
            onValueUpdate: function(selectedDates, dateStr, instance) {
                for (const callback of onUpdateValueCallbacks) {
                    callback(dateStr, instance);
                }

                rEvent.dispatch('Datepicker.valueUpdated', dateStr, instance);
            }
        }, ...options})

        el.classList.add('is-datepicker.initialized')
    }
}

